class Chain {
    constructor() {
        this.devices = [];
    }
    contains(device) {
        return this.devices.indexOf(device) > -1;
    }
    number() { return this.devices.length; }
}
export default Chain;
//# sourceMappingURL=Chain.js.map